// React & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";

// Components
import { CivilStatusTableColumn } from "../../../../Data/DataTables/CivilStatus";
import FilterComponent from "../../Common/FilterComponent";

// Types
import { ViewCivilStatus } from "../../../../Types/MasterData/CivilStatus";

// Services
import {
  VIEW_CIVILSTATUS_QUERY_KEY,
  civilstatusService,
} from "../../../../Services/civilstatusService";

const CivilStatusTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_CIVILSTATUS_QUERY_KEY,
    queryFn: civilstatusService.getAllViewCivilStatus,
  });
  const filteredItems: ViewCivilStatus[] = usersResponse?.data.filter(
    (item: ViewCivilStatus) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={CivilStatusTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default CivilStatusTable;
